
















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AccountProfileComponents } from '@/enums/AccountProfileComponents';
import { UserData } from '@/interfaces/UserData';
import { ElForm } from 'element-ui/types/form';
import { ElUploadInternalFileDetail, HttpRequestOptions } from 'element-ui/types/upload';
import { ElUploadInterface } from '@/interfaces/ElUploadInterface';
import { ajaxUrls } from '@/helpers/ajaxUrlsHelper';
import { Action } from 'vuex-class';
import { endpoints } from '../../../config/endpoints';

interface FormInterface {
    updateEmailForm: ElForm,
}

interface UploadInterface {
    upload: ElUploadInterface
}

@Component({
    name: 'AccountProfileEditDetails',
})
export default class AccountProfileEditDetails extends Vue {
    public $refs!: Vue['$refs'] & FormInterface & UploadInterface;

    @Prop({required: true}) public userData!: UserData;
    @Action('user/getMe') protected getMe!: () => void;
    @Action('user/updateUserData') protected updateUserData!: (userData: object) => void;
    @Action('user/uploadProfilePicture') protected uploadProfilePicture!: (image: ElUploadInternalFileDetail) => void;
    @Action('user/removeProfilePicture') protected removeProfilePicture!: () => void;
    @Action('user/getCountryList') protected getCountryList!: () => {};

    protected get userImage() {
        if (this.userData.profilePicture) {
            return this.userData.profilePicture.largeSizeUrl;
        }
        if (this.userData.firstName && this.userData.lastName) {
            return this.userData.firstName.slice(0, 1).toUpperCase() + this.userData.lastName.slice(0, 1).toUpperCase();
        }
        return false;
    }

    protected get uploadUrl() {
        return endpoints.rest + '/' + ajaxUrls.user.profilePicture;
    }

    protected get countryList() {
        return this.$store.getters['user/countryList'];
    }

    protected profileDetailsForm = {
        firstName: '',
        lastName: '',
        title: '',
        company: '',
        streetAddress: '',
        city: '',
        stateProvince: '',
        postalCode: '',
        profileCountry: '',
    };

    protected formRules = {
        firstName: [{
          required: true, message: 'Please input the first name', trigger: 'change',
        }],
        lastName: [{
          required: true, message: 'Please input the last name', trigger: 'change',
        }],
        company: [{
          required: true, message: 'Please input the company name', trigger: 'change',
        }],
        profileCountry: [{
            required: true, message: 'Please select the profile country', trigger: 'change',
        }],
    };

    protected imageData = {};

    protected toggleComponent(componentName: keyof typeof AccountProfileComponents) {
        this.$emit('toggle-component', AccountProfileComponents[componentName]);
    }

    protected saveProfileDetails() {
        // todo - send details to api
        this.toggleComponent('Edit');
    }

    protected submitForm(formName: keyof FormInterface) {
        this.$refs[formName].validate(async (valid) => {
            if (valid) {
                await this.updateUserData(this.profileDetailsForm);
                this.toggleComponent('Overview');
            } else {
                return false;
            }
        });
    }

    protected cancelProfileDetails() {
        this.toggleComponent('Edit');
    }

    protected mounted() {
        this.getCountryList();
        this.profileDetailsForm.firstName = this.userData.firstName ?
            this.userData.firstName : '';
        this.profileDetailsForm.lastName = this.userData.lastName ?
            this.userData.lastName : '';
        this.profileDetailsForm.title = this.userData.title ?
            this.userData.title : '';
        this.profileDetailsForm.company = this.userData.company ?
            this.userData.company : '';
        this.profileDetailsForm.streetAddress = this.userData.streetAddress ?
            this.userData.streetAddress : '';
        this.profileDetailsForm.city = this.userData.city ?
            this.userData.city : '';
        this.profileDetailsForm.stateProvince = this.userData.stateProvince ?
            this.userData.stateProvince : '';
        this.profileDetailsForm.postalCode = this.userData.postalCode ?
            this.userData.postalCode : '';
        this.profileDetailsForm.profileCountry = this.userData.country ?
            this.userData.country.id : '';
    }

    protected beforeAvatarUpload(file: File) {
        const isLt2M = file.size / 1024 / 1024 < 0.4;

        if (!isLt2M) {
            this.$message.error('Avatar picture size can not exceed 400kB!');
        }

        return isLt2M;

    }

    protected async onUpload(e: HttpRequestOptions) {
        await this.uploadProfilePicture(e.file);
        this.$refs.upload.clearFiles();
    }

    protected async onRemoveProfilePicture() {
        this.removeProfilePicture();
    }
}
